import { TaxonomyNodeType } from '@modules/taxonomyV2/types';
import {
  FormatQuoteRounded,
  GroupWorkOutlined,
  TagRounded,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { LabelType } from 'generated/graphql';

interface TaxonomyFieldIconProps extends SvgIconProps {
  type: TaxonomyNodeType | LabelType;
}

export const TaxonomyFieldIcon = ({
  type,
  ...iconProps
}: TaxonomyFieldIconProps) => {
  if (type === 'l1' || type === LabelType.L1) {
    return <GroupWorkOutlined {...iconProps} />;
  }

  if (type === 'trackedKeyword' || type === LabelType.Aspect) {
    return <TagRounded {...iconProps} />;
  }

  if (type === 'reason' || type === LabelType.Reason) {
    return <FormatQuoteRounded {...iconProps} />;
  }

  return null;
};
